import React, {Component} from 'react'
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Constants from "../../utils/constants";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import Select from "react-select";
import SvGraphics from "../../assets/SvGraphics";

class BloodThinnerMedications extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            bloodThinner_medications: this.props.bloodThinner_medications,
            medicationsList: this.props.medicationsList,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
        this.setState({Currently_taking: this.state.entry.Currently_taking==="Yes"})

    }

    handleAllergicsMultiChange(event){
        this.props.onClickPatientAllergics(event)
    }
    handleMedicationChange(option,index) {
        this.props.onClickAddDeleteMedications(index , option, "Med_ID","BT")
    }

    render() {
        let {t} = this.props

        let {entry}= this.state
        let bloodThinner_medications =this.props.bloodThinner_medications
        let medicationsList =this.props.medicationsList


        let medicationsListArr=[]
        for(let i=0;i<medicationsList.length;i++){
            if(medicationsList[i].BloodThinner || medicationsList[i].Medication_name==="Other"){
                medicationsListArr.push({value:medicationsList[i].Med_ID, label:medicationsList[i].Medication_name})
            }
        }

        let medicationsArr = bloodThinner_medications.map( (item, index) =>
            <div style={{display:entry.take_bloodThinning ==="Yes" ?'block':'none'}}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Med_ID')}</label>
                        <PatientSelectComponent
                            className={'multipleSelectBox'}
                            placeholder={t('patient_boarding.med_choose')}
                            options={medicationsListArr}
                            value={item.MedObj}
                            onChange={this.handleMedicationChange.bind(this,index)}
                        />

                    </div>
                     <div className={'inputSlots'} style={{display: item.Medication_name==="Other"?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_boarding.enter_med')}</label>
                        <input className={'inputBoxStyle'} type="text" name="Med_ID" id="Med_ID"
                               defaultValue={item.OtherMed}
                               maxLength={25}
                               onChange={event => this.props.onClickAddDeleteMedications(index, event.target.value, "OtherMed","BT")}/>
                    </div>
                    <div className={'inputSlots-delete-icon'}>
                        <SvGraphics className={"delete-icon-medication"}
                                    onClick={() => this.props.addDeleteMedication("deleteThinner",index)} svgname={'delete-icon'}/>
                    </div>
                </div>
                <div className={'patientsFormRow'}>

                        <div className={'inputSlots'}>
                            <label className={'infoLabel'}>{t('patient_boarding.Dose')}:</label>
                            <input className={'inputBoxStyle'} type="number"  name="Dosage_mg_day" id="Dosage_mg_day" value={item.Dosage_mg_day}
                                   maxLength={5} min={0} max={99999}
                                   onChange={event => this.props.onClickAddDeleteMedications(index , event.target.value, "Dosage_mg_day","BT")}/>
                        </div>

                        <div className={'inputSlots'}>
                            <label className={'infoLabel-Empty'}/>
                                <select className={'selectBox'} id="Dosage_unit" name="Dosage_unit" value={item.Dosage_unit}
                                        onChange={event => this.props.onClickAddDeleteMedications(index , event.target.value, "Dosage_unit","BT")}>
                                    <option value="mg">mg</option>
                                    <option value="mcg">mcg</option>
                                    <option value="gr">gr</option>
                                    <option value="ml">ml</option>
                                </select>

                        </div>
                </div>
                <div className={'patientsFormRow'}>

                <div className={'inputSlotsHalfBlock'}>
                            <label className={'infoLabel'}>{t('patient_boarding.Treatment_duration')}</label>
                        <div className={'medication-duration-boxes'}>
                        <div className={item.Duration==="-1"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "-1" ,"Duration","BT")}>
                                {t('patient_boarding.less_than_month')}
                            </div>
                            <div className={item.Duration==="1-6"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "1-6" ,"Duration","BT")}
                            >{t('patient_boarding.1_6M')}</div>
                            <div className={item.Duration==="6-12"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "6-12" ,"Duration","BT")}
                            >{t('patient_boarding.6_12M')}</div>
                            <div className={item.Duration==="12+"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "12+" ,"Duration","BT")}
                            >{t('patient_boarding.1+Y')}</div>
                        </div>
                    </div>
                </div>
                <div className={'patientsFormRow'}>
                    <div className={'line-space'}/>
                </div>
            </div>

        )

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} id={'drug'}>
                        <div className={'infoLabel-error-block'}>
                            <label
                                className={'infoLabel-withError'}>{t('patient_boarding.take_bloodThinning')}</label>
                        </div>

                        <button tabIndex={0}
                                className={entry.take_bloodThinning === "Yes" ? 'inputBoxStyle-yes-no-left-selected' : 'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("take_bloodThinning", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}
                                className={entry.take_bloodThinning === "No" ? 'inputBoxStyle-yes-no-middle-selected' : 'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.props.onYesNoValueChange("take_bloodThinning", "No")}>{t('patient_boarding.no')}</button>
                        <button tabIndex={0}
                                className={entry.take_bloodThinning === "Unknown" ? 'inputBoxStyle-yes-no-right-selected' : 'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("take_bloodThinning", "Unknown")}>{t('patient_boarding.Unknown')}</button>
                    </div>
                </div>
             {medicationsArr}
                {entry.take_bloodThinning ==="Yes" &&<div className={'patientsFormRow'}>
                    <div className={'svg-label'} onClick={() => this.props.addDeleteMedication("addThinner", bloodThinner_medications.length)}>
                        <SvGraphics className={"delete-icon"} svgname={'add-icon'}/>
                        <div className={'addTarget'} >{t('patient_boarding.add_medication')}</div>
                    </div>
                </div>}
            </div>

        )
    }
}

BloodThinnerMedications.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default BloodThinnerMedications;
